import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormType } from '../../backend/openapi/api-types';
import { AnonymousForm } from './anonoymous-form';

export const NewUserForExistingCustomerForm: React.FC = () => {
  const { t } = useTranslation();

  return (
    <AnonymousForm
      documentTitle={t('form.createNewUserForExistingCustomer.documentTitle')}
      formType={FormType.createNewUserForExistingCustomer}
    />
  );
};
